import { EntityAboutCard, EntityHasSystemsCard, EntityLayout } from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { Grid } from '@material-ui/core';
import entityWarningContent from '../../components/entity-content/entity-warning-content';
import { EnvModuleComponents } from '@internal/plugin-dynamic-environment';

export const DomainPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard height={400} />
        </Grid>
        <Grid item md={6}>
          <EntityHasSystemsCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/environments" title="Environments">
      <EnvModuleComponents.DashboardEnvironmentsModule />
    </EntityLayout.Route>
  </EntityLayout>
);
